import { useState, useEffect } from 'react';

export interface DeviceType {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  screenWidth: number;
  screenHeight: number;
  orientation: 'portrait' | 'landscape';
}

export function useDeviceType(): DeviceType {
  const [deviceType, setDeviceType] = useState<DeviceType>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    screenWidth: 0,
    screenHeight: 0,
    orientation: 'landscape'
  });

  useEffect(() => {
    const updateDeviceType = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const orientation = height > width ? 'portrait' : 'landscape';

      setDeviceType({
        isMobile: width < 768,
        isTablet: width >= 768 && width < 1024,
        isDesktop: width >= 1024,
        screenWidth: width,
        screenHeight: height,
        orientation
      });
    };

    // 初始检测
    updateDeviceType();

    // 监听窗口大小变化
    window.addEventListener('resize', updateDeviceType);
    window.addEventListener('orientationchange', updateDeviceType);

    return () => {
      window.removeEventListener('resize', updateDeviceType);
      window.removeEventListener('orientationchange', updateDeviceType);
    };
  }, []);

  return deviceType;
}

// 便捷hooks
export function useIsMobile(): boolean {
  const { isMobile } = useDeviceType();
  return isMobile;
}

export function useIsTablet(): boolean {
  const { isTablet } = useDeviceType();
  return isTablet;
}

export function useIsDesktop(): boolean {
  const { isDesktop } = useDeviceType();
  return isDesktop;
}

export function useOrientation(): 'portrait' | 'landscape' {
  const { orientation } = useDeviceType();
  return orientation;
}
